import type {PropsWithChildren} from 'react';
import React from 'react';
import {CircularProgress, Container} from '@tempo/core';
import {Topbar, TitleDescription} from '@app/components/Layouts/elements';
import {AccountSections} from '../elements/stacks/AccountSections';
import type {LoadableLayout} from './types';

/**
 * Simple "in-app" layout that only displays the form and
 * titles + description with a coherent padding and structure
 */
export const InAppFormLayout: React.FC<
	PropsWithChildren<{
		title?: string;
		detail?: string;
		topbar?: React.ReactNode;
	}> &
		LoadableLayout
> = ({children, title, detail, isLoading, topbar}) => {
	return (
		<>
			{topbar ?? <Topbar />}
			<Container width="100%" maxW="container.lg" minHeight="100%" pb={38}>
				<AccountSections>
					{isLoading ? (
						<CircularProgress
							isIndeterminate
							data-testid="layout-loader"
							pt="spacing.3xl"
						/>
					) : (
						<>
							{!!title && <TitleDescription title={title} detail={detail} />}
							{children}
						</>
					)}
				</AccountSections>
			</Container>
		</>
	);
};
